<div class="tab-content" *ngIf="!isMultiDocument">
  <div>
    <ecpl-document-explorer
      [uploaderConfig]="upConfig"
      [uploadedFiles]="uploadedFiles"
      (saveChanges)="saveUploaded($event)"
      (toogleEditDisplayMode)="toggleEditMode($event)"
      (showDocumentDialog)="showDocumentDailog()"
    >
    </ecpl-document-explorer>
    <div class="action-btns-wrapper">
      <button
        class="btn btn-primary"
        [ngClass]="{ loading: loading }"
        [disabled]="
          loading ||
          (newDocumentAdded?.length <= 0 && selectedArticles.length <= 0)
        "
        type="button"
        *ngIf="hasRights"
        (click)="saveDoc()"
      >
        <span translate>SAVE</span>
      </button>
      <button
        class="btn btn-primary"
        *ngIf="isEditor && hasRights"
        type="button"
        [disabled]="
          loading ||
          (newDocumentAdded?.length <= 0 &&
            uploadedFiles.length < 25 &&
            !uploadedFiles.some(hasUnapprovedDocument))
        "
        (click)="Approve(1)"
      >
        <span translate>SEND_APPROVAL_NOTICE</span>
      </button>
      <button
        class="btn btn-primary"
        *ngIf="isUser"
        type="button"
        [disabled]="
          loading || newDocumentAdded?.length > 0 || isFileSeclected()
        "
        (click)="Approve(3)"
      >
        <span translate>APPROVE </span>
      </button>
    </div>
  </div>

  <div class="table-view mt-3" *ngIf="trainerPendingDocs.length > 0">
    <div class="page-title">
      <h4 translate>CONFIRM_TRAINING</h4>
    </div>
    <p-table
      [value]="trainerPendingDocs"
      [(selection)]="selectedTrainerDocs"
      dataKey="id"
      [rows]="10"
    >
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 55px">
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>
          <th>{{ "DOCUMENT_NAME" | translate }}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-document>
        <tr>
          <td style="width: 55px">
            <p-tableCheckbox [value]="document"></p-tableCheckbox>
          </td>
          <td>{{ document.filename }}</td>
        </tr>
      </ng-template>
    </p-table>
    <div class="mt-2 d-flex align-items-center">
      <label class="mb-0 mr-2"><span translate>TRAINING_DATE</span></label>
      <p-datepicker
        class="mr-2"
        [(ngModel)]="trainerConfirmDate"
        [maxDate]="maxTrainingDate"
        dateFormat="dd/mm/yy"
        [showIcon]="true"
        appendTo="body"
      ></p-datepicker>
      <button
        class="btn btn-primary"
        type="button"
        [disabled]="
          loading || selectedTrainerDocs.length === 0 || !trainerConfirmDate
        "
        (click)="confirmTrainingGiven()"
      >
        <span translate>CONFIRM_TRAINING</span>
      </button>
    </div>
  </div>

  <div class="saving-loader overlay" *ngIf="showSavingLoader">
    <div class="saving-loader-message text-center">
      <img src="/assets/icons/blocks.gif" alt="" />
      <p translate>SAVING</p>
    </div>
  </div>
</div>

<div class="tab-content" *ngIf="isMultiDocument">
  <div class="page-title">
    <span translate>{{ title }}</span>
  </div>

  <div class="table-view mb-3">
    <label for="documents" class="control-label" translate>DOCUMENTS</label>
    <!-- Table starts -->
    <p-table
      #employee
      [value]="emp"
      dataKey="EmployeeId"
      [rows]="10"
      [paginator]="true"
      [pageLinks]="3"
      [rowsPerPageOptions]="[5, 10, 20]"
      expandableRows="true"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="{{ 'SUMMARY_TOTALRECORDS' | translate }}"
      (onHeaderCheckboxToggle)="onTableHeaderCheckboxToggle()"
      [(selection)]="selectedEmployeesForApproval"
    >
      <!-- Caption -->
      <ng-template pTemplate="caption">
        <div class="ui-helper-clearfix">
          <div class="filter-controls-wrapper" style="display: block">
            <div class="row mb-2">
              <div class="col-auto">
                <label for="documentname" class="col-form-label" translate
                  >SEARCH</label
                >
              </div>
              <div class="col-sm-6">
                <input
                  type="text"
                  pInputText
                  size="50"
                  (input)="filterResults($any($event.target)?.value)"
                />
              </div>
              <div class="col-auto ml-auto">
                <div class="dropdown">
                  <a
                    href="javascript:void(0);"
                    class="btn p-3 toggle-action-btn"
                  >
                    <i class="pi pi-download"></i>
                    <span translate>EXPORT</span>
                  </a>
                  <div class="export-btns">
                    <button
                      type="button"
                      class="dropdown-item"
                      (click)="exportReport('xlsx')"
                    >
                      <i class="icon ic-sm icon-xls mr-2"></i>
                      <span translate>EXCEL</span>
                    </button>
                    <button
                      type="button"
                      class="dropdown-item"
                      (click)="exportReport('docx')"
                    >
                      <i class="icon ic-sm icon-word mr-2"></i>
                      <span translate>WORD</span>
                    </button>
                    <button
                      type="button"
                      class="dropdown-item"
                      (click)="exportReport('pdf')"
                    >
                      <i class="icon ic-sm icon-pdf mr-2"></i>
                      <span translate>PDF</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
      <!-- Header -->
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 55px">
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>
          <th style="width: 55px"></th>
          <th pSortableColumn="EmployeeName">
            {{ "NAME" | translate }}
            <p-sortIcon field="EmployeeName"></p-sortIcon>
          </th>
          <th pSortableColumn="DepartmentName">
            {{ "DEPARTMENT" | translate }}
            <p-sortIcon field="DepartmentName"></p-sortIcon>
          </th>
          <th pSortableColumn="BusinessName" *ngIf="isPortal">
            {{ "BUSINESS_NAME" | translate }}
            <p-sortIcon field="BusinessName"></p-sortIcon>
          </th>
          <th pSortableColumn="ApprovedStatus" style="width: 80px">
            {{ "STATUS" | translate }}
            <p-sortIcon field="ApprovedStatus"></p-sortIcon>
          </th>
          <th pSortableColumn="TypeOfEmployee">
            {{ "TYPE_OF_EMPLOYEE" | translate }}
            <p-sortIcon field="TypeOfEmployee"></p-sortIcon>
          </th>
        </tr>
        <tr>
          <th></th>
          <th></th>
          <th>
            <input
              pInputText
              type="text"
              (input)="
                employee.filter(
                  $any($event.target)?.value,
                  'EmployeeName',
                  'contains'
                )
              "
              placeholder=""
              class="p-column-filter"
            />
          </th>
          <th>
            <p-select
              width="118px"
              [options]="departmentOptions"
              (onChange)="
                employee.filter($event.value, 'DepartmentName', 'equals')
              "
              styleClass="p-column-filter"
              [showClear]="true"
              appendTo="body"
            >
              <ng-template let-department pTemplate="item">
                {{ department.label | translate }}
              </ng-template>
            </p-select>
          </th>
          <th *ngIf="isPortal">
            <input
              pInputText
              type="text"
              (input)="
                employee.filter(
                  $any($event.target)?.value,
                  'BusinessName',
                  'contains'
                )
              "
              placeholder=""
              class="p-column-filter"
            />
          </th>
          <th></th>
          <th>
            <p-select
              width="118px"
              [options]="typeList"
              (onChange)="
                employee.filter($event.value, 'TypeOfEmployee', 'equals')
              "
              styleClass="p-column-filter"
              [showClear]="true"
              appendTo="body"
            >
              <ng-template let-document pTemplate="item">
                {{ document.label | translate }}
              </ng-template>
            </p-select>
          </th>
        </tr>
      </ng-template>
      <!-- Body Content -->
      <ng-template
        pTemplate="body"
        let-employees
        let-expanded="expanded"
        let-i="rowIndex"
      >
        <tr>
          <td style="width: 55px">
            <p-tableCheckbox id="selectedOrders" [value]="employees">
            </p-tableCheckbox>
          </td>
          <td
            style="display: flex; justify-content: center; align-items: center"
          >
            <a
              (click)="employee.toggleRow(employees)"
              class="btn btn-icon"
              style="border: none"
            >
              <span
                class="icon ic-sm icon-expand-arrow"
                aria-hidden="true"
                *ngIf="setCollapse(i)"
                (click)="toggleClick(i)"
              ></span>
              <span
                class="icon ic-sm icon-collapse-arrow"
                aria-hidden="true"
                *ngIf="!setCollapse(i)"
                (click)="toggleClickHide(i)"
              ></span>
            </a>
          </td>

          <td>{{ employees.EmployeeName }}</td>
          <td>{{ employees.DepartmentName }}</td>
          <td *ngIf="isPortal">{{ employees.BusinessName }}</td>
          <td>{{ employees.ApprovedStatus }}</td>
          <td>{{ employees.TypeOfEmployee }}</td>
        </tr>
      </ng-template>
      <!-- Empty message -->
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td colspan="6">
            {{ "NO_RECORDS_FOUND" | translate }}
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="expandedrow" let-docs>
        <tr>
          <td colspan="6">
            <div>
              <!-- Table starts -->
              <p-table [value]="docs.EmployeeDocuments" [rows]="5">
                <!-- Header -->
                <ng-template pTemplate="header">
                  <tr>
                    <th pSortableColumn="Filename">
                      {{ "DOCUMENT_NAME" | translate }}
                      <p-sortIcon field="Filename"></p-sortIcon>
                    </th>
                    <th pSortableColumn="ApprovedOn" width="125px">
                      {{ "DATE_APPROVE" | translate }}
                      <p-sortIcon field="ApprovedOn"></p-sortIcon>
                    </th>
                    <th pSortableColumn="CreatedBy">
                      {{ "UPLOADED_BY" | translate }}
                      <p-sortIcon field="CreatedBy"></p-sortIcon>
                    </th>
                    <th pSortableColumn="TrainedById">
                      {{ "TRAINED_BY" | translate }}
                      <p-sortIcon field="TrainedById"></p-sortIcon>
                    </th>
                    <th pSortableColumn="TrainedOn" width="125px">
                      {{ "TRAINED_ON" | translate }}
                      <p-sortIcon field="TrainedOn"></p-sortIcon>
                    </th>
                    <th width="75px"></th>
                  </tr>
                </ng-template>
                <!-- Body Content -->
                <ng-template pTemplate="body" let-document>
                  <tr>
                    <td>
                      <div
                        class="truncate-data"
                        style="margin-right: 0.5px; display: flex"
                        pTooltip="{{ document.Filename | translate }}"
                        tooltipPosition="top"
                      >
                        <document-preview
                          [path]="document.Path"
                          [filename]="document.Filename"
                          [documentId]="document.Id"
                          [isArticle]="document.IsArticle"
                          [documentType]="document.DocumentType"
                        ></document-preview>
                        <div class="ml-2">
                          {{ document.Filename }}
                        </div>
                      </div>
                    </td>
                    <td>
                      <span>{{
                        document.ApprovedOn | date: "dd/MM/yyyy"
                      }}</span>
                    </td>
                    <td>
                      <span>{{ document.CreatedBy }}</span>
                    </td>
                    <td>
                      <span *ngIf="!canAssignTrainer(document)">{{
                        getEmployeeName(document.TrainedById)
                      }}</span>
                      <p-select
                        *ngIf="canAssignTrainer(document)"
                        [options]="employees"
                        [(ngModel)]="existingTrainedBy[document.Id]"
                        [ngModelOptions]="{ standalone: true }"
                        (onChange)="onTrainerSelected(document, $event.value)"
                        (onClear)="onTrainerSelected(document, null)"
                        [filter]="true"
                        [showClear]="true"
                        appendTo="body"
                        [style]="{ width: '160px' }"
                        placeholder="{{ 'SELECT' | translate }}"
                      ></p-select>
                    </td>
                    <td>
                      <span *ngIf="!canConfirmTraining(document)">{{
                        document.TrainedOn | date: "dd/MM/yyyy"
                      }}</span>
                      <div
                        *ngIf="canConfirmTraining(document)"
                        class="d-flex align-items-center"
                      >
                        <p-datepicker
                          [(ngModel)]="inlineTrainingDates[document.Id]"
                          [maxDate]="maxTrainingDate"
                          dateFormat="dd/mm/yy"
                          appendTo="body"
                          [style]="{ width: '120px' }"
                        ></p-datepicker>
                        <button
                          class="btn btn-primary ml-1"
                          type="button"
                          [disabled]="
                            loading || !inlineTrainingDates[document.Id]
                          "
                          (click)="confirmSingleTraining(document)"
                        >
                          <span translate>CONFIRM_TRAINING</span>
                        </button>
                      </div>
                    </td>
                    <td width="75px" class="col-button">
                      <button
                        (click)="deleteDoc(document.Id)"
                        type="button"
                        title="{{ 'DELETE' | translate }}"
                        [attr.aria-label]="'DELETE' | translate"
                        class="kuba-icon-btn kuba-icon-btn--danger kuba-icon-btn--row"
                      >
                        <i class="pi pi-trash"></i>
                      </button>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
              <!-- Table ends -->
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
    <!-- Table ends -->
  </div>

  <div class="documentrow">
    <div>
      <button
        class="btn btn-outline-success"
        *ngIf="hasRights"
        (click)="showDocumentDailog()"
      >
        <span translate>ADD_FROM_MANUAL</span>
      </button>
      <button
        class="btn btn-outline-success"
        *ngIf="hasRights && hasQualitySystem"
        (click)="showQSDocumentDailog()"
      >
        <span translate>ADD_FROM_QUALITYSYSTEMS</span>
      </button>
      <button
        class="btn btn-outline-success"
        *ngIf="hasRights && hasOtherSystem"
        (click)="showOSDocumentDailog()"
      >
        <span translate>ADD_FROM_OTHERSYSTEMS</span>
      </button>
      <button
        class="btn btn-outline-success"
        *ngIf="hasRights && hasInternalControl"
        (click)="showICDocumentDailog()"
      >
        <span translate>ADD_FROM_INTERNALCONTROL</span>
      </button>
      <ecpl-document-explorer
        [uploaderConfig]="upConfigApp"
        [uploadedFiles]="uploadedFiles"
        (saveChanges)="saveUploaded($event)"
      >
      </ecpl-document-explorer>
    </div>
  </div>
  <div class="action-btns-wrapper">
    <div class="form-group trained-by-select" *ngIf="isEditor || hasRights">
      <label><span translate>TRAINED_BY</span></label>
      <p-select
        [(ngModel)]="selectedTrainedById"
        [options]="employees"
        [filter]="true"
        [showClear]="true"
        [style]="{ 'min-width': '200px' }"
        placeholder="{{ 'SELECT' | translate }}"
      >
      </p-select>
    </div>
    <button
      class="btn btn-primary"
      [ngClass]="{ loading: loading }"
      [disabled]="
        loading ||
        (!hasPendingTrainerAssignments &&
          ((newDocumentAdded?.length <= 0 && selectedArticles?.length <= 0) ||
            selectedEmployeesForApproval?.length <= 0))
      "
      type="button"
      (click)="saveDocumentsAndTrainers()"
    >
      <span translate>SAVE</span>
    </button>
    <button
      class="btn btn-primary"
      *ngIf="isEditor || hasRights"
      type="button"
      [disabled]="
        loading ||
        selectedEmployeesForApproval?.length <= 0 ||
        (newDocumentAdded?.length <= 0 &&
          !selectedEmployeesForApproval.some(hasDocumentsForApproval))
      "
      (click)="Approve(1)"
    >
      <span translate>SEND_APPROVAL_NOTICE</span>
    </button>
  </div>
</div>
<p-dialog
  header="{{ 'UPLOAD' | translate }}"
  [(visible)]="ShowPopUp"
  overflow="inherit"
  [style]="{ width: '500px' }"
  [resizable]="false"
  [draggable]="false"
>
  <div class="form-group">
    <label for="appPerson">
      <span translate>SELECT_MANUAL</span>
      <span class="required">*</span>
    </label>
    <div>
      <p-select
        [(ngModel)]="selectedManual"
        (ngModelChange)="SelectManual($event)"
        [options]="manualList"
        placeholder="{{ 'SELECT_A_MANUAL' | translate }}"
        [filter]="true"
        [style]="{ width: '100%' }"
        [disabled]="selectingManual"
      >
      </p-select>
    </div>
  </div>
  <div
    *ngIf="selectingManual"
    style="
      height: 315px;
      display: flex;
      align-items: center;
      justify-content: center;
    "
  >
    <kuba-busy [busy]="selectingManual" message="PROCESSING"></kuba-busy>
  </div>
  <div
    class="mbtm-10 manual-tree-scroll"
    *ngIf="showArchiveDocumentDailog && !selectingManual"
  >
    <app-ecpl-document-tree
      *ngIf="treeNode"
      treeId="adminManualsTree"
      [(ecplTreeData)]="treeNode"
      [(ecplActiveNode)]="treeActiveNode"
      [(ecplTreeCheckbox)]="addManualsEdit"
      [addFromManuals]="addFromManuals"
      (ecplNodeEvent)="catchEvent($event)"
      [(ecplApiResponse)]="apiResponse"
    >
    </app-ecpl-document-tree>
  </div>
  <ng-template pTemplate="footer">
    <button
      [disabled]="
        selectedManual == null || selectingManual || !hasCheckedFiles()
      "
      class="btn btn-primary"
      type="button"
      (click)="addArticlesToPrivateDocs()"
    >
      <span translate>ADD</span>
    </button>
  </ng-template>
</p-dialog>
<p-dialog
  header="{{ 'UPLOAD' | translate }}"
  [(visible)]="QualitydocumentPopUp"
  overflow="inherit"
  [style]="{ width: '500px' }"
  [resizable]="false"
  [draggable]="false"
>
  <div class="form-group">
    <label for="appPerson">
      <span translate>SELECT_MANUAL</span>
      <span class="required">*</span>
    </label>
    <div>
      <p-select
        [(ngModel)]="selectedManual"
        (ngModelChange)="SelectManual($event)"
        [options]="qualityList"
        placeholder="{{ 'SELECT_DOCUMNETS' | translate }}"
        [filter]="true"
        [style]="{ width: '100%' }"
        [disabled]="selectingManual"
      >
      </p-select>
    </div>
  </div>
  <div
    *ngIf="selectingManual"
    style="
      height: 315px;
      display: flex;
      align-items: center;
      justify-content: center;
    "
  >
    <kuba-busy [busy]="selectingManual" message="PROCESSING"></kuba-busy>
  </div>
  <div
    class="mbtm-10 manual-tree-scroll"
    *ngIf="showArchiveDocumentDailog && !selectingManual"
  >
    <app-ecpl-document-tree
      *ngIf="treeNode"
      treeId="adminManualsTree"
      [(ecplTreeData)]="treeNode"
      [(ecplActiveNode)]="treeActiveNode"
      [(ecplTreeCheckbox)]="addManualsEdit"
      [addFromManuals]="addFromManuals"
      (ecplNodeEvent)="catchEvent($event)"
      [(ecplApiResponse)]="apiResponse"
    >
    </app-ecpl-document-tree>
  </div>
  <ng-template pTemplate="footer">
    <button
      [disabled]="
        selectedManual == null || selectingManual || !hasCheckedFiles()
      "
      class="btn btn-primary"
      type="button"
      (click)="addArticlesToPrivateDocs()"
    >
      <span translate>ADD</span>
    </button>
  </ng-template>
</p-dialog>
<p-dialog
  header="{{ 'UPLOAD' | translate }}"
  [(visible)]="otherdocumentPopUp"
  overflow="inherit"
  [style]="{ width: '500px' }"
  [resizable]="false"
  [draggable]="false"
>
  <div class="form-group">
    <label for="appPerson">
      <span translate>SELECT_MANUAL</span>
      <span class="required">*</span>
    </label>
    <div>
      <p-select
        [(ngModel)]="selectedManual"
        (ngModelChange)="SelectManual($event)"
        [options]="otherList"
        placeholder="{{ 'SELECT_DOCUMNETS' | translate }}"
        [filter]="true"
        [style]="{ width: '100%' }"
        [disabled]="selectingManual"
      >
      </p-select>
    </div>
  </div>
  <div
    *ngIf="selectingManual"
    style="
      height: 315px;
      display: flex;
      align-items: center;
      justify-content: center;
    "
  >
    <kuba-busy [busy]="selectingManual" message="PROCESSING"></kuba-busy>
  </div>
  <div
    class="mbtm-10 manual-tree-scroll"
    *ngIf="showArchiveDocumentDailog && !selectingManual"
  >
    <app-ecpl-document-tree
      *ngIf="treeNode"
      treeId="adminManualsTree"
      [(ecplTreeData)]="treeNode"
      [(ecplActiveNode)]="treeActiveNode"
      [(ecplTreeCheckbox)]="addManualsEdit"
      [addFromManuals]="addFromManuals"
      (ecplNodeEvent)="catchEvent($event)"
      [(ecplApiResponse)]="apiResponse"
    >
    </app-ecpl-document-tree>
  </div>
  <ng-template pTemplate="footer">
    <button
      [disabled]="
        selectedManual == null || selectingManual || !hasCheckedFiles()
      "
      class="btn btn-primary"
      type="button"
      (click)="addArticlesToPrivateDocs()"
    >
      <span translate>ADD</span>
    </button>
  </ng-template>
</p-dialog>
<p-dialog
  header="{{ 'UPLOAD' | translate }}"
  [(visible)]="internalControlPopUp"
  overflow="inherit"
  [style]="{ width: '500px' }"
  [resizable]="false"
  [draggable]="false"
>
  <div class="form-group">
    <label for="appPerson">
      <span translate>SELECT_INTERNAL_CONTROL</span>
      <span class="required">*</span>
    </label>
    <div>
      <p-select
        [(ngModel)]="selectedManual"
        (ngModelChange)="SelectManual($event)"
        [options]="internalControlList"
        placeholder="{{ 'SELECT_DOCUMNETS' | translate }}"
        [filter]="true"
        [style]="{ width: '100%' }"
        [disabled]="selectingManual"
      >
      </p-select>
    </div>
  </div>
  <div
    *ngIf="selectingManual"
    style="
      height: 315px;
      display: flex;
      align-items: center;
      justify-content: center;
    "
  >
    <kuba-busy [busy]="selectingManual" message="PROCESSING"></kuba-busy>
  </div>
  <div
    class="mbtm-10 manual-tree-scroll"
    *ngIf="showArchiveDocumentDailog && !selectingManual"
  >
    <app-ecpl-document-tree
      *ngIf="treeNode"
      treeId="adminManualsTree"
      [(ecplTreeData)]="treeNode"
      [(ecplActiveNode)]="treeActiveNode"
      [(ecplTreeCheckbox)]="addManualsEdit"
      [addFromManuals]="addFromManuals"
      (ecplNodeEvent)="catchEvent($event)"
      [(ecplApiResponse)]="apiResponse"
    >
    </app-ecpl-document-tree>
  </div>
  <ng-template pTemplate="footer">
    <button
      [disabled]="
        selectedManual == null || selectingManual || !hasCheckedFiles()
      "
      class="btn btn-primary"
      type="button"
      (click)="addArticlesToPrivateDocs()"
    >
      <span translate>ADD</span>
    </button>
  </ng-template>
</p-dialog>

<kuba-busy [busy]="loading" message="PROCESSING"></kuba-busy>
